import { FC } from 'react';

import { FlatList, StyleSheet } from 'react-native';

import { spacing } from 'styles/constants';

import { IncentiveCard } from '../loyalty-incentives-components/incentive-card/incentive-card';

import { EnrichedReward, ILoyaltyRewardsCategoryList } from './types';

export const LoyaltyRewardsCategoryList: FC<ILoyaltyRewardsCategoryList> = ({
  rewards,
  locked,
  handleOnPress,
  inCooldown,
}) => {
  return (
    <FlatList
      showsHorizontalScrollIndicator={false}
      horizontal
      style={styles.flatList}
      contentContainerStyle={styles.contentContainer}
      data={rewards}
      keyExtractor={(item: any) => (item as EnrichedReward).rewardId}
      overScrollMode={'never'}
      renderItem={({ item }) => {
        const { rewardId, incentive, inlineAlertMessage, isApplied } = item as EnrichedReward;
        return incentive && rewardId ? (
          <IncentiveCard
            key={rewardId}
            incentive={incentive}
            handlePress={handleOnPress}
            locked={locked || false}
            inlineAlertMessage={inlineAlertMessage}
            isPictureBlurhashEnabled={false}
            isApplied={isApplied}
            inCooldown={inCooldown}
          />
        ) : null;
      }}
    />
  );
};

const styles = StyleSheet.create({
  flatList: {
    paddingLeft: spacing.$4,
    flex: 1,
  },
  contentContainer: {
    paddingRight: 24,
  },
});
